import {NonFunctionProperties} from '@colonist/types'

export class ClientUserSessionState {
    /**
     * This is the user session id, not the user id
     */
    id: string

    static deserialize(data: NonFunctionProperties<ClientUserSessionState>): ClientUserSessionState {
        const user = new ClientUserSessionState()
        user.id = data.id
        return user
    }
}
